import type { ReactNode } from "react";

import { Box } from "../../components/ui/box";
import type { Omittable } from "../../lib/props";

export type WidgetRowRailProps = Omittable<{
  children: ReactNode;
}>;

/**
 * A row's hover rail: chrome that takes no room in the row's cross axis. The
 * rail is a zero-height centre line its 28px buttons overhang by 4px into the
 * row's own padding, so a 36px row stays 36px with the rail hidden or shown
 * and every list that seats one keeps a single row pitch. Revealed on the
 * row's hover, or by a held press on a coarse pointer.
 */
export function WidgetRowRail({ children }: WidgetRowRailProps) {
  return (
    <Box align="center" className="h-0" direction="row" gap="xs" hoverReveal="row">
      {children}
    </Box>
  );
}
